import _ from 'lodash'

export default invoiceDetail

/** @ngInject */
function invoiceDetail(Invoice, ErrorCatcher) {
    return ({
        restrict: 'E',
        scope: {
            invoice: '=',
        },
        template: require('./invoiceDetail.jade')(),
        link(scope) {
            scope.actions = {
                payStatus: { SUCCESS: 'SUCCESS', FAIL: 'FAIL', PENDING: 'PENDING', POD: 'POD' },
                isDetailOpen: false,
            }

            scope.getInvoiceLabel = (type) => {
                const INVOICE_LABEl_MAPPING = {
                    REG: 'Facture de régularisation',
                    REG_FINAL: 'Facture de clôture',
                    MISC: 'Facture de frais',
                    REG_REVERSAL: 'Annulation de la facture de régularisation',
                    REG_FINAL_REVERSAL: 'Annulation de la facture de clôture',
                    MISC_REVERSAL: 'Annulation de la facture de frais',
                }
                return _.get(INVOICE_LABEl_MAPPING, type, 'Facture')
            }

            scope.sendInvoiceByMail = (id) => {
                Invoice.sendInvoiceByMail({ id_invoice: id }).$promise
                .catch(ErrorCatcher.catchError)
            }
        },
    })
}



// WEBPACK FOOTER //
// ./src/states/invoice/component/invoiceDetail.js